"use client";

import { useEffect, useState } from "react";

import {
  GAM_BASE_TOP_MOBILE_AD_UNIT,
  GAM_BASE_TOP_MOBILE_ENABLED,
  GAM_BASE_TOP_MOBILE_MIN_HEIGHT,
  GAM_BASE_TOP_MOBILE_SIZES,
} from "@/components/ads/config";
import GamDisplaySlot from "@/components/ads/GamDisplaySlot";

import styles from "./BaseArticle.module.css";

type TargetingValue =
  | string
  | number
  | boolean
  | Array<string | number | boolean>;

type Props = {
  targeting?: Record<string, TargetingValue | null | undefined>;
};

const MOBILE_QUERY = "(max-width: 767px)";

export default function BaseSimpleDisplayAd({ targeting }: Props) {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY);

    const update = () => {
      setIsMobile(mediaQuery.matches);
    };

    update();
    mediaQuery.addEventListener("change", update);

    return () => {
      mediaQuery.removeEventListener("change", update);
    };
  }, []);

  if (!GAM_BASE_TOP_MOBILE_ENABLED || isMobile !== true) {
    return null;
  }

  return (
    <div
      className={`${styles.displayAdWrap} ${styles.fallbackSupportAdWrap}`}
      data-base-mobile-ad="support-banner"
      data-base-mobile-ad-role="secondary-banner"
    >
      <div className={`${styles.adBox} ${styles.fallbackSupportAdBox}`}>
        <div className={styles.adHeader}>
          <span className={styles.sponsored}>Sponsored</span>
        </div>

        <GamDisplaySlot
          id="base-top-mobile"
          adUnit={GAM_BASE_TOP_MOBILE_AD_UNIT}
          sizes={[...GAM_BASE_TOP_MOBILE_SIZES]}
          minHeight={GAM_BASE_TOP_MOBILE_MIN_HEIGHT}
          lazyRootMargin="800px 0px"
          targeting={{
            page_type: "base",
            device: "mobile",
            position: "after_strengths_banner",
            placement: "base_top_mobile_secondary_banner",
            placement_detail: "base_top_mobile_lazy_after_strengths_320x100",
            placement_group: "support_mobile",
            inventory_tier: "support_banner",
            bfc_ad_mode: "secondary_banner",
            demand_formats: ["display", "banner"],
            ...targeting,
          }}
        />
      </div>
    </div>
  );
}
